import {endpointKeys} from '@common/api'
import {PartnerAdminPractitionerTimeOffSummary} from '@common/models'
import {partnerAdminPractitionerTimeOffSummariesNormaliser} from '@common/normalisers'

import {useWebGet, useApi} from './helpers'

/**
 * Hook to get aggregated practitioners time off (Partner Admin scope)
 * Calls GET /api/v1/partner-administrators/practitioners/time-off
 */
export const useGetPartnerAdminPractitionersTimeOff = () =>
  useWebGet<PartnerAdminPractitionerTimeOffSummary[]>(
    [endpointKeys.partnerAdminPractitionersTimeOff],
    useApi().partnerAdminPractitionersTimeOff(),
    partnerAdminPractitionerTimeOffSummariesNormaliser,
  )
